import { Caregiver } from "@/model/Organization"

export const caregiverName = (caregiver?: Caregiver) => {
  if (!caregiver) return ""
  return caregiver.schedulingName && caregiver.schedulingName.trim()
    ? `${caregiver.displayName} (${caregiver.schedulingName})`
    : caregiver.displayName
}

export const formatPhoneNumber = (value: string): string => {
  const digits = value.replace(/^\+1/, "").replace(/\D/g, "")
  if (digits.length === 0) return ""
  if (digits.length <= 3) return `(${digits}`
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
}
